export default {
  Brag: {
    SETUP: 'Setup',
    REC_LOG: 'Reconciliation Log',
    Setup: {
      BROWSER_OPTIONS: 'To get started, first install Mayday\'s extension for your browser:',
      NOT_AVAILABLE: 'Mayday\'s Browser Extension is not currently available for {{name}}.',
      INSTALL: 'Install the Mayday Extension for {{name}}',
      MAPPING_ONBOARDING: 'Tell us where the intercompany loan accounts live between each of the organisations so we can post credits and debits to the right places.',
      MAPPING: 'Use this page to configure intercompany loan account codes in each Xero organisation. When a payment in one organisation relates to a bill in another, these accounts will be debited and credited as appropriate.',
    },
    RecLog: {
      Type: {
        payment: 'Payment',
        received: 'Receipt',
        spend: 'Spend Money',
        createReceive: 'Receive Money',
      },
      Headers: {
        contact: 'Contact',
        received: 'Received',
        reference: 'Reference',
      },
    },
  },
};
